import React, { useState } from "react";
import { Button } from "react-bootstrap";

import type { Message } from "../../hooks/reactQueryHooks/useRequests";
import { PromptWithContext } from "../PromptWithContext";
import { RequestSidebarMessage } from "./RequestSidebarMessage";

interface RequestSidebarQuestionProps {
  messages: Message[];
  promptContext: {
    query: string;
    context: string;
  } | null;
}

const RequestSidebarQuestion: React.FC<RequestSidebarQuestionProps> = ({
  messages,
  promptContext,
}) => {
  const [showAll, setShowAll] = useState(false);

  const handleToggleClick = () => {
    setShowAll(!showAll);
  };

  const messagesCount = messages?.length || 0;

  return (
    <>
      <div className="d-flex align-items-center  request-sidebar-item">
        <h4>Prompt</h4>
      </div>

      {promptContext ? (
        <div className="request-sidebar-message">
          <h5>User</h5>
          <PromptWithContext
            question={promptContext.query}
            context={promptContext.context}
          />
        </div>
      ) : (
        <>
          {messagesCount > 1 && (
            <div className="d-flex align-center justify-content-center">
              <Button variant="outline-light" onClick={handleToggleClick}>
                {showAll ? "Hide" : "Show"} all messages
              </Button>
            </div>
          )}
          {showAll ? (
            messages.map((message: any, i: number) => (
              <RequestSidebarMessage
                key={i}
                role={message.role}
                message={message.content || ""}
                toolCalls={message.toolCalls}
              />
            ))
          ) : (
            <RequestSidebarMessage
              role={messages[messagesCount - 1]?.role || "User"}
              message={
                messages[messagesCount - 1]?.content || "No messages sent"
              }
            />
          )}
        </>
      )}
    </>
  );
};

export { RequestSidebarQuestion };
